import React from "react";
import { StatusBadge } from "./styled";
import { StatusLabel } from "./types";

interface EisFundInvestmentStatusProps {
  statusLabel: StatusLabel | null;
}

/**
 * Renders an investment status badge.
 * Returns null if no status label is assigned.
 */
const EisFundInvestmentStatus: React.FC<EisFundInvestmentStatusProps> = ({
  statusLabel,
}) => {
  // Don't render if no status label
  if (!statusLabel) {
    return null;
  }

  return (
    <StatusBadge
      $backgroundColor={statusLabel.bgColor}
      $textColor={statusLabel.textColor}
      data-testid="eis-investment-status"
    >
      {statusLabel.name}
    </StatusBadge>
  );
};

export default EisFundInvestmentStatus;
